import { render } from "./translate-modal.vue?vue&type=template&id=f940b172"
import script from "./translate-modal.vue?vue&type=script&lang=js"
export * from "./translate-modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/translation/resources/vue/translation/translate-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f940b172"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f940b172', __exports__)) {
    console.log('reload')
    api.reload('f940b172', __exports__)
  }
  
  module.hot.accept("./translate-modal.vue?vue&type=template&id=f940b172", () => {
    console.log('re-render')
    api.rerender('f940b172', render)
  })

}


export default __exports__